module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "xs12": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-select', {
          attrs: {
            "items": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            "label": "Select",
            "light": "",
            "single-line": "",
            "auto": ""
          },
          model: {
            value: (props.item.quantity),
            callback: function($$v) {
              _vm.$set(props.item, "quantity", $$v)
            },
            expression: "props.item.quantity"
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.cost))])]
      }
    }]),
    model: {
      value: (_vm.cart),
      callback: function($$v) {
        _vm.cart = $$v
      },
      expression: "cart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right mt-3"
  }, [_vm._v("\n        Total: " + _vm._s(_vm.total) + "\n      ")])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "text-xs-center mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "blue-grey",
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.loader = 'loading'
      }
    }
  }, [_vm._v("\n      下一步\n      "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("keyboard_arrow_right")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41f82e06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cart.vue
// module id = 779
// module chunks = 1